export const RecordBtnStatus = {
    DISABLE: 0, // 0：不能开始录音
    INITIAL: 1, // 1：可以点击录音
    RECORDING: 2, // 2：录音中可以结束录音
}

export const RecordTimeMin = 3 // 最短录音时间，单位秒

export const EvalMode = {
    FREE: 'freedom',
    PARAGRAPH: 'paragraph',
}
